export const EMAIL_RESOURCE_TYPES: string[] = ['email'];
